const debounce = (func, time = 150) => {
  let timer;

  return (event) => {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(func, time, event);
  };
};

export default debounce;
